import { Link } from 'react-router-dom'

function AboutFour() {
   return (
      <div className="about-area position-relative overflow-hidden overflow-hidden space" id="about-sec">
         <div className="container shape-mockup-wrap">
            <div className="row">
               <div className="col-xl-7">
                  <div className="img-box3">
                     <div className="img1">
                        <img src="/assets/img/normal/about_3_1.jpg" alt="About" />
                     </div>
                     <div className="img2">
                        <img src="/assets/img/normal/about_3_2.jpg" alt="About" />
                     </div>
                     <div className="img3 movingX">
                        <img src="/assets/img/normal/about_3_3.jpg" alt="About" />
                     </div>
                  </div>
               </div>
               <div className="col-xl-5">
                  <div className="ps-xl-4">
                     <div className="title-area mb-20">
                        <span className="sub-title style1 ">Welcome to Himolan Peak Adventures</span>
                        <h2 className="sec-title mb-20 pe-xl-5 me-xl-5 heading">
                           Your Trusted Adventure Partner in Northern Pakistan
                        </h2>
                     </div>
                     <p className="pe-xl-5">
                        Based in Skardu, Gilgit-Baltistan, Himolan Peak Adventures is your trusted partner in exploring the breathtaking beauty of Northern Pakistan. We specialize in unforgettable mountain tours, trekking expeditions, camping trips, and adventure experiences designed for nature lovers and thrill seekers.
                     </p>
                     <p className="mb-30 pe-xl-5">
                        From the blossom valleys of Skardu to the cherry orchards of Hunza, the alpine meadows of Fairy Meadows to the colorful lakes of Naltar — we bring you closer to the true spirit of adventure. Every tour is carefully crafted to give you the most authentic and memorable experience of Pakistan's majestic north.
                     </p>
                     <div className="about-item-wrap">
                        <div className="about-item style2">
                           <div className="about-item_img">
                              <img src="/assets/img/icon/about_1_1.svg" alt="" />
                           </div>
                           <div className="about-item_centent">
                              <h5 className="box-title">Experienced Local Guides</h5>
                              <p className="about-item_text">
                                 Our professional guides know every trail, valley, and hidden gem of Gilgit-Baltistan.
                              </p>
                           </div>
                        </div>
                        <div className="about-item style2">
                           <div className="about-item_img">
                              <img src="/assets/img/icon/about_1_2.svg" alt="" />
                           </div>
                           <div className="about-item_centent">
                              <h5 className="box-title">Safety First Approach</h5>
                              <p className="about-item_text">
                                 We prioritize your safety with first aid, experienced drivers, and fully planned itineraries.
                              </p>
                           </div>
                        </div>
                        <div className="about-item style2">
                           <div className="about-item_img">
                              <img src="/assets/img/icon/about_1_3.svg" alt="" />
                           </div>
                           <div className="about-item_centent">
                              <h5 className="box-title">Flexible Custom Packages</h5>
                              <p className="about-item_text">
                                 We offer affordable, customized tour packages tailored to your group size and preferences.
                              </p>
                           </div>
                        </div>
                     </div>
                     <div className="mt-35">
                        <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style3 th-icon">
                           Contact With Us
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
            <div
               className="shape-mockup movingX d-none d-xxl-block"
               style={{ top: '0%', left: '-18%' }}
            >
               <img src="/assets/img/shape/shape_2_1.png" alt="shape" />
            </div>
            <div
               className="shape-mockup jump d-none d-xxl-block"
               style={{ top: '28%', right: '-15%' }}
            >
               <img src="/assets/img/shape/shape_2_2.png" alt="shape" />
            </div>
            <div
               className="shape-mockup spin d-none d-xxl-block"
               style={{ top: '18%', left: '-112%' }}
            >
               <img src="/assets/img/shape/shape_2_3.png" alt="shape" />
            </div>
            <div
               className="shape-mockup movixgX d-none d-xxl-block"
               style={{ bottom: '18%', right: '-12%' }}
            >
               <img src="/assets/img/shape/shape_2_4.png" alt="shape" />
            </div>
         </div>
      </div>
   )
}

export default AboutFour

